import { Snackbar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";

import ProductService from "../services/ProductService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EditSubFamily = ({ setOnEditSubFamily, oldSubFamilyData }) => {

  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [name, setName] = useState();
  const [desc, setDesc] = useState();

  useEffect(() => {
    setName(oldSubFamilyData.name);
    setDesc(oldSubFamilyData.description);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeName = (event) => {
    setName(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnEditSubFamily(false);
  };



  const onAddSubFamily = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    } else {
      ProductService.updateSubFamily(
        getCurrentUserId(),
        oldSubFamilyData.idSubFamily,
        name,
        desc
      )
        .then((response) => {
          setOpenAlert(true);

          setOnEditSubFamily(false);
          setOpen(false);
          window.location.reload(false);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        id="edit-subfamily"
        style={{ display: "block", background: "#00000066" }}
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Modifier la sous-famille</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Libellé</label>
                    <input
                      defaultValue={name}
                      onChange={onChangeName}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Description</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                    defaultValue={desc}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onAddSubFamily}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
      {
        open && <Snackbar
          open={openAlert}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleClose} severity="success">
            Ajout avec success !
          </Alert>
        </Snackbar>
      }

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditSubFamily;
